import { authApiService } from '../../authApiService';
import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';

export const logoutApi = async (): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = `/users/logout/`;

  return authApiService.POST(uri, {});
};
